<template>
  <div>
    <div class="table-header">
      <div>
        <el-radio-group v-model="tabPosition" style="margin-bottom: 20px" @change="handleTabChange">
          <el-radio-button label="有效">有效</el-radio-button>
          <el-radio-button label="失效">失效</el-radio-button>
        </el-radio-group>
      </div>
      <div>
        <el-button type="primary" size="small" @click="handleAdd" :disabled="!canEdit"
          >添加</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerStyle"
      :row-class-name="tableRowClassName"
      v-loading="loading"
    >
      <el-table-column label="序号" align="center" width="80" type="index"></el-table-column>
      <el-table-column prop="name" label="姓名" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.name || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="idCard" label="身份证" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.idCard || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="电话" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.phone || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="company" label="所属单位" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.company || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="area" label="合作区域/园区" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.areas && scope.row.areas.length" class="tag-container">
            <el-tag
              v-for="(area, index) in scope.row.areas"
              :key="index"
              size="small"
              type="success"
              class="skill-tag"
              >{{ area }}</el-tag
            >
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column prop="category" label="人员类别" align="center">
        <template slot-scope="scope">
          <span style="color: #219aff">{{ scope.row.category || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="skills" label="技能标签" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.skills && scope.row.skills.length" class="tag-container">
            <el-tag
              v-for="(skill, index) in scope.row.skills"
              :key="index"
              size="small"
              type="success"
              class="skill-tag"
              >{{ skill }}</el-tag
            >
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.status || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-dropdown @command="(command) => handleCommand(command, scope.row)">
            <span class="el-dropdown-link">
              更多操作 <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit" :disabled="!canEdit">编辑</el-dropdown-item>
              <el-dropdown-item
                command="delete"
                :disabled="!isAuthorizedUser() || scope.row.status !== '失效' || !canEdit"
                >删除</el-dropdown-item
              >
              <el-dropdown-item command="history">历史记录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageParams.skip"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageParams.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 编辑抽屉 -->
    <el-drawer
      :title="isEdit ? '编辑合作资源人员' : '添加合作资源人员'"
      :visible.sync="dialogVisible"
      direction="rtl"
      size="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="form"
          :rules="rules"
          label-width="120px"
          label-position="right"
          ref="employeeForm"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证" prop="idCard">
            <el-input v-model="form.idCard" placeholder="请输入身份证号码"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="所属单位" prop="partnerId">
            <el-select
              v-model="form.partnerId"
              placeholder="请选择所属单位"
              style="width: 100%"
              @change="handlePartnerChange"
            >
              <el-option
                v-for="item in partnerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合作区域/园区" prop="areas">
            <el-select
              v-model="form.areas"
              multiple
              placeholder="请选择合作区域/园区"
              style="width: 100%"
             @focus="handleSelectFocus">
                  <el-option
                    v-for="(item, index) in campusOptions"
                    :key="index"
                    :label="Object.values(item)[0]"
                    :value="Object.values(item)[0]"
                  ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员类别" prop="category">
            <el-select v-model="form.category" placeholder="请选择人员类别" style="width: 100%">
              <el-option label="计费HC" value="计费HC"></el-option>
              <el-option label="专职专项" value="专职专项"></el-option>
              <el-option label="合作专项" value="合作专项"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="技能标签" prop="skills">
            <el-select
              v-model="form.skills"
              multiple
              placeholder="请选择技能标签"
              style="width: 100%"
            >
              <el-option label="网络复检" value="网络复检"></el-option>
              <el-option label="服务器专项" value="服务器专项"></el-option>
              <el-option label="资源交付" value="资源交付"></el-option>
              <el-option label="特殊变更" value="特殊变更"></el-option>
              <el-option label="裁撤相关" value="裁撤相关"></el-option>
              <el-option label="改造" value="改造"></el-option>
              <el-option label="资产" value="资产"></el-option>
              <el-option label="机架裁撤" value="机架裁撤"></el-option>
              <el-option label="ODF裁撤" value="ODF裁撤"></el-option>
              <el-option label="专线裁撤" value="专线裁撤"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
              <el-option label="有效" value="有效"></el-option>
              <el-option label="失效" value="失效"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">确定</el-button>
            <el-button @click="handleClose">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <history-dialog :visible.sync="historyDialogVisible" :partnerId="currentEmployeeId" />
  </div>
</template>

<script>
import {
  getPartnerEmployeeList,
  createPartnerEmployee,
  updatePartnerEmployee,
  deletePartnerEmployee,
  getPartnerEmployeeById,
  getPartnerEmployeeLogs,
} from '@/api/partner_employee';
import { getPartnerList } from '@/api/partner';
import HistoryDialog from './HistoryDialog.vue';
import { getCampusList } from '@/api/operation';
export default {
  components: {
    HistoryDialog,
  },
  data() {
    return {
      headerStyle: {
        background: '#F5F7FA',
        color: '#303133',
        fontWeight: 'bold',
        textAlign: 'center',
      },
      loading: false,
      total: 0,
      pageParams: {
        skip: 1,
        limit: 10,
        status: '有效',
      },
      tabPosition: '有效',
      tableData: [],
      dialogVisible: false,
      drawerTitle: '',
      form: {
        name: '',
        idCard: '',
        phone: '',
        partnerId: '',
        company: '',
        areas: [],
        category: '',
        skills: [],
        status: '有效',
        remark: '',
      },
      campusOptions: [], // 用于存储园区接口返回的数据
      hasLoaded: false, // 添加标志位防止重复加载
      partnerList: [],
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        idCard: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '请输入正确的身份证号码',
            trigger: 'blur',
          },
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' },
        ],
        partnerId: [{ required: true, message: '请选择所属单位', trigger: 'change' }],
        areas: [{ required: true, message: '请选择合作区域/园区', trigger: 'change' }],
        category: [{ required: true, message: '请选择人员类别', trigger: 'change' }],
        skills: [{ required: true, message: '请选择技能标签', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isEdit: false,
      editIndex: -1,
      historyDialogVisible: false,
      currentEmployeeId: null,
    };
  },
  computed: {
    canEdit() {
      const userId = localStorage.getItem('UserId');
      const userList = JSON.parse(localStorage.getItem('userList') || '[]');
      const currentUser = userList.find((user) => user.name === userId);
      return currentUser && currentUser.editPermission;
    },
  },
  methods: {
    //园区获取数据接口
    async getCampusData() {  
      try {
        const params = {
          spec_sign: 0,
        };
        const response = await getCampusList(params);
        if (response.data && response.data.code === 200) {
          this.campusOptions = response.data.data; 
          this.hasLoaded = true;
          //console.log("成功设置 campusOptions:", this.campusOptions)
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },
    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    handleAdd() {
      this.drawerTitle = '添加员工';
      this.isEdit = false;
      this.form = {
        name: '',
        idCard: '',
        phone: '',
        partnerId: '',
        areas: [],
        category: '',
        skills: [],
        status: '有效',
        remark: '12312',
      };
      this.dialogVisible = true;
    },
    async handleCommand(command, row) {
      this.currentEmployeeId = row.id;
      switch (command) {
        case 'edit':
          this.drawerTitle = '编辑合作资源人员';
          this.isEdit = true;
          this.editIndex = this.tableData.findIndex((item) => item.id === row.id);
          try {
            const res = await getPartnerEmployeeById(row.id);
            if (res.data && res.data.data) {
              const employeeData = res.data.data;
              this.form = {
                name: employeeData.data.name || '',
                idCard: employeeData.data.id_card || '',
                phone: employeeData.data.phone || '',
                partnerId: employeeData.data.partner_id || '',
                company: '',
                areas: employeeData.data.regions ? JSON.parse(employeeData.data.regions) : [],
                category: employeeData.data.personnel_category || '',
                skills: employeeData.data.skill_tags
                  ? JSON.parse(employeeData.data.skill_tags)
                  : [],
                status: employeeData.data.status || '有效',
                remark: employeeData.data.remark || '',
              };
              // 设置所属单位名称
              const partner = this.partnerList.find((p) => p.id === employeeData.partner_id);
              if (partner) {
                this.form.company = partner.name;
              }
              this.currentEmployeeId = row.id;
              this.dialogVisible = true;
            } else {
              this.$message.error('获取员工详情数据格式错误');
            }
          } catch (error) {
            this.$message.error('获取详情失败：' + error.message);
          }
          break;
        case 'delete':
          this.$confirm('确认删除该员工信息吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              try {
                await deletePartnerEmployee(row.id);
                this.$message.success('删除成功');
                this.getList();
              } catch (error) {
                this.$message.error('删除失败：' + error.message);
              }
            })
            .catch(() => {});
          break;
        case 'history':
          this.historyDialogVisible = true;
          break;
        default:
          break;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async submitForm() {
      try {
        const submitData = {
          name: this.form.name,
          id_card: this.form.idCard,
          phone: this.form.phone,
          partner_id: this.form.partnerId,
          regions: Array.isArray(this.form.areas) ? JSON.stringify(this.form.areas) : '[]',
          personnel_category: this.form.category,
          skill_tags: Array.isArray(this.form.skills) ? JSON.stringify(this.form.skills) : '[]',
          status: this.form.status,
          remark: this.form.remark,
          operator: localStorage.getItem('UserId') || 'admin',
        };
        await this.$refs.employeeForm.validate();

        if (this.isEdit) {
          await updatePartnerEmployee(this.currentEmployeeId, submitData);
          this.$message.success('编辑成功');
        } else {
          await createPartnerEmployee(submitData);
          this.$message.success('添加成功');
        }
        this.dialogVisible = false;
        this.getList();
      } catch (error) {
        if (error.message) {
          this.$message.error('操作失败：' + error.message);
        }
      }
    },
    async getList() {
      this.loading = true;
      try {
        await this.getPartnerList();
        const res = await getPartnerEmployeeList(this.pageParams);
        this.tableData = (res.data.data.list || []).map((item) => {
          const partner = this.partnerList.find((p) => p.id === item.partner_id);
          return {
            id: item.id,
            name: item.name,
            idCard: item.id_card,
            phone: item.phone,
            company: partner ? partner.name : '-',
            areas: item.regions
              ? typeof item.regions === 'string'
                ? JSON.parse(item.regions)
                : []
              : [],
            category: item.personnel_category,
            skills: item.skill_tags
              ? typeof item.skill_tags === 'string'
                ? JSON.parse(item.skill_tags)
                : []
              : [],
            status: item.status,
          };
        });
        this.total = res.data.data.total || 0;
      } catch (error) {
        this.$message.error('获取列表失败：' + error.message);
      } finally {
        this.loading = false;
      }
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageParams.skip = val;
      this.getList();
    },
    handleTabChange() {
      this.pageParams.status = this.tabPosition;
      this.getList();
    },
    handleHistory() {
      this.historyDialogVisible = true;
    },
    isAuthorizedUser() {
      const authorizedUsers = ['韩林达', '周德明', '何文卷', '陈伟锋'];
      const currentUser = localStorage.getItem('UserId') || '';
      return authorizedUsers.includes(currentUser);
    },
    async getPartnerList() {
      try {
        const res = await getPartnerList({ status: '有效', limit: -1 });
        this.partnerList = res.data.data.list || [];
      } catch (error) {
        this.$message.error('获取合作单位列表失败：' + error.message);
      }
    },
    handlePartnerChange(value) {
      const partner = this.partnerList.find((item) => item.id === value);
      if (partner) {
        this.form.company = partner.name;
      }
    },
  },
  created() {
    this.getPartnerList();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.box-card {
  margin-bottom: 20px;
}
.table-header {
  display: flex;
  justify-content: space-between;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

::v-deep .el-table {
  th.el-table__cell {
    background-color: #4e71be !important;
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
      color: #fff;
    }
  }
  th.el-table__cell:first-child {
    border: 0.5px solid #fff;
  }
  .el-table__header {
    border-color: #fff;
  }
  td.el-table__cell {
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
    }
  }
  td.el-table__cell:first-child {
    background-color: #4e71be !important;
    color: #fff;
  }
  tr:hover > td.el-table__cell:first-child {
    background-color: #4e71be !important;
  }
}

::v-deep .el-table .even-row {
  background-color: #ced4e8;
}

::v-deep .el-table .odd-row {
  background-color: #e9ebf3;
}

::v-deep .el-table td.el-table__cell .cell {
  white-space: normal !important;
}

.pagination-container {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
}

.skill-tag {
  margin: 2px;
}
</style>